var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BgImageLayout',{attrs:{"title":"Define your custom form"}},[_c('q-card',{staticClass:"bg-white"},[_c('q-card-section',[_c('FormGenerator',{attrs:{"form-data":_vm.formData},on:{"update":_vm.updateForm,"save":_vm.saveForm}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }